import React, { useState, useEffect } from 'react';
import { nodeAPI, deviceAPI } from '../services/api';
import './NodeRegistration.css';

function NodeRegistration({ onNodeRegistered }) {
  const [devices, setDevices] = useState([]);
  const [formData, setFormData] = useState({
    nodeId: '',
  meterName: '',
    deviceId: '',
    description: '',
    location: '',
    nodeName: 'Heyy',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    fetchDevices();
  }, []);

  const fetchDevices = async () => {
    try {
      const response = await deviceAPI.getAll();
      setDevices(response.data.data || []);
    } catch (error) {
      console.error('Error fetching devices:', error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await nodeAPI.register(formData);
      setMessage({ type: 'success', text: response.data.message });
      setFormData({
        nodeId: '',
  meterName: '',
        deviceId: formData.deviceId,
        description: '',
        location: ''
      });
      if (onNodeRegistered) {
        onNodeRegistered(response.data.data);
      }
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.message || 'Failed to register node'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="registration-form">
      <h2>Register New Node</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="deviceId">Select Device *</label>
          <select
            id="deviceId"
            name="deviceId"
            value={formData.deviceId}
            onChange={handleChange}
            required
          >
            <option value="">-- Select Device --</option>
            {devices.map((device) => (
              <option key={device._id} value={device.deviceId}>
                {device.deviceName} ({device.deviceId})
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="nodeId">Node ID *</label>
          <input
            type="text"
            id="nodeId"
            name="nodeId"
            value={formData.nodeId}
            onChange={handleChange}
            required
            placeholder="e.g., NODE001"
          />
        </div>

        <div className="form-group">
            <label htmlFor="meterName">Node Name *</label>
          <input
            type="text"
            id="meterName"
            name="meterName"
            value={formData.meterName}
            onChange={handleChange}
            required
            placeholder="e.g., Meter 1"
          />
        </div>

        <div className="form-group">
          <label htmlFor="description">Description</label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Optional description"
            rows="3"
          />
        </div>

        <div className="form-group">
          <label htmlFor="location">Location</label>
          <input
            type="text"
            id="location"
            name="location"
            value={formData.location}
            onChange={handleChange}
            placeholder="e.g., Room 101"
          />
        </div>

        {message.text && (
          <div className={`message ${message.type}`}>
            {message.text}
          </div>
        )}

        <button type="submit" disabled={loading || !formData.deviceId} className="submit-btn">
          {loading ? 'Registering...' : 'Register Node'}
        </button>
      </form>
    </div>
  );
}

export default NodeRegistration;
